import Axios from 'axios';
import Head from 'next/head';
import React, { useEffect, useState } from 'react';
import getMetaTagData from '../../../src/common/services/getMetaTagData';
import ServiceNotice from '../../../src/component/pc/pass/ServiceNotice';

import cookieCutter from 'cookie-cutter';
import { toStringByDateFormat } from "../../../src/common/utils/dateUtil";
import { getLnbList, isIOS } from "../../../src/common/utils/passUtil";
import PointGroup from "../../../src/component/pc/pass/point/pointGroup";
import SlideBanner from "../../../src/component/pc/pass/SlideBanner";

function Point({ metaTagData, pointData, topEventBannerData }) {

  //jwt 토큰 관리
  const [login_jwt, setLogin_jwt] = useState();
  const [platform, setPlatform] = useState();
  const [sbs_id, setLogin_Id] = useState();
  const [isFoldBannerOpen, setIsFoldBannerOpen] = useState(false);

  //화면시작시 최초 한번 시작...
  useEffect(async () => {
    window.scrollTo(0, 0);
    const LOGIN_JWT = cookieCutter.get('LOGIN_JWT'); //로그인 토큰 가져오는 부분
    const platformCookie = cookieCutter.get('JOIN_PLATFORM');
    const SBS_ID = cookieCutter.get('SBS_USER_ID');

    setLogin_jwt(LOGIN_JWT);
    setPlatform(platformCookie);
    setLogin_Id(SBS_ID);

  }, []);

  const foldBannerOpenToggleHandler = () => {
    if (isFoldBannerOpen) {
      setIsFoldBannerOpen(false);
    } else {
      setIsFoldBannerOpen(true);
    }
  };

  const eventStyle = isFoldBannerOpen ? {
    transition: "",
    transform: "",
    WebkitTransition: "height .3s ease",
    height: "100%",
    display: "block"
  } : {
    transition: "",
    transform: "",
    WebkitTransition: "",
    height: "",
    display: "none"
  }

  return (
    <>
      <Head>
        <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_2023_PC_PASSMONEY_URL} />
        <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
        <script key='gnb_js_url' type='text/javascript' src={process.env.NEXT_PUBLIC_GNB_JS_URL} />
        <script src='//developers.kakao.com/sdk/js/kakao.min.js' />
        <meta name='description' content={metaTagData.shareDescription} />
        <meta name='keywords' content={metaTagData.keywords} />
        <meta name='twitter:card' content='summary' />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property='og:type' content='website' />
        <meta property='og:locale' content='ko_KR' />
        <meta property='og:site_name' content='SBS' />
        <meta property='og:title' content={metaTagData.shareTitle || ''} />
        <meta property='og:description' content={metaTagData.shareDescription || ''} />8
        <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
        <meta property='og:url' content={metaTagData.currentUrl || ''} />
        <meta name='nate:site_name' content='SBS' />
        <meta name='nate:title' content={metaTagData.shareTitle || ''} />
        <meta name='nate:description' content={metaTagData.shareDescription || ''} />
        <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
        <meta name='nate:url' content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>

      <div id="container" className="contents">
        <div className="passmoneyContents">{/* 페이지 명 클래스  */}
          {getLnbList('pc')}
          <div className="passmoneyCont_point">
            {/* 스와이퍼 배너영역 */}
            {topEventBannerData && (<SlideBanner data={topEventBannerData} />)}
            <div className="pointContents">
              <div className="pointTopBnr">
                <strong className="title">S포인트를 이용해서 쿠폰을 구매할 수 있어요</strong>
                <img className="img" src="/images/pass/point_top_info01.png" alt="쿠폰이미지" />
              </div>
              {pointData.point_group && (<PointGroup data={pointData.point_group} loginJwt={login_jwt} />)}
            </div>
            <div className="pointInfoWrap">
              <div className="pointTitle">
                <strong className="title_id">{sbs_id ? sbs_id : '고객'}</strong>님<br />
                <em className="title_text">포인트 받는 방법</em> 알려드릴게요!
                <i className="bg"><img src="/images/pass/pointBg01.png" alt="" /></i>
              </div>
              <ul className="pointInfoList">
                <li className="pointInfoItem item01">
                  <div className="pointInfoBox">
                    <i className="img"><img src="/images/pass/point_info01.png" /></i>
                    <strong className="title">VOD 광고 보고 최대 <em className="number">1,000P</em></strong>
                    <p className="subText">로그인 후 15초 영상과 광고를 시청할<br />때마다 적립돼요. (하루 최대 1,000P)</p>
                  </div>
                </li>
                <li className="pointInfoItem item02">
                  <div className="pointInfoBox">
                    <i className="img"><img src="/images/pass/point_info02.png" /></i>
                    <strong className="title">뱃지 미션으로 최대 <em className="number">1,000P</em></strong>
                    <p className="subText">앱에서 참여 가능한 뱃지 미션 달성 시<br />최대 1,000P 받을 수 있다고!</p>
                  </div>
                </li>
                <li className="pointInfoItem item03">
                  <div className="pointInfoBox">
                    <i className="img"><img src="/images/pass/point_info03.png" /></i>
                    <strong className="title">이벤트 참여하고 최대 <em className="number">10,000P</em></strong>
                    <p className="subText">룰렛 이벤트, 스타 출첵 이벤트 참여 시<br />매일매일 포인트 지급!</p>
                  </div>
                </li>
              </ul>
            </div>
            <div className="noticeList_wrap">
              {pointData.service_notice && (<ServiceNotice data={pointData.service_notice} />)}
            </div>
            <div className="contents_bottom_ad">
              <div className="bottom_ad_inner">
                <iframe title='배너광고' display='block' src='/html/pc/point.htm' width='970px' height='90px' scrolling='no' frameBorder='0' align='middle' marginWidth='0' marginHeight='0' />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

const getPointData = async () => {
  let result = null;

  //console.log('NEXT_PUBLIC_API_POINT_KO :>> ', process.env.NEXT_PUBLIC_API_POINT_KO);

  try {
    const pointData = await Axios.get(process.env.NEXT_PUBLIC_API_POINT_KO, { timeout: 3000 });
    result = pointData.data ? { ...pointData.data } : null;

    //console.log(result);

  } catch (error) {
    console.error(error);
    result = null;
  }

  return result;
};

const getTopEventBanner = async () => {
  let result = null;

  try {
    const today = toStringByDateFormat(new Date);

    const topEventBannerData = await Axios.get(process.env.NEXT_PUBLIC_API_TOP_EVENT_BANNER_POINT, { timeout: 3000 });

    result = topEventBannerData.data ? { ...topEventBannerData.data } : null;
    result = result.top_event_banner.filter(topEventBanner => topEventBanner.start_date <= today && topEventBanner.end_date >= today)

  } catch (error) {
    console.error(error);
    result = null;
  }

  return result;
};

export async function getServerSideProps(ctx) {
  //console.log('getServerSideProps');
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { cookies } = ctx.req;
  const { LOGIN_JWT } = cookies;
  const { JOIN_PLATFORM } = cookies;
  const { pageSection, pageCategory } = ctx.query;

  let metaTagData;
  let pointData;
  let topEventBannerData;

  try {
    metaTagData = getMetaTagData(ctx.req.url, 'point', pageCategory); // 메타 데이터 불러오는 부분(각페이지마다 있어야함)
    pointData = await getPointData();
    topEventBannerData = await getTopEventBanner();
  } catch (error) {
    console.error(error);
  }

  return {
    props: {
      pointData: pointData,
      metaTagData,
      topEventBannerData: topEventBannerData
    }
  };
}

export default Point;